import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from './plugins/axios'
import './plugins/apexchart'
import router from './router'
import store from './store'
import read from './plugins/read'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  axios,
  store,
  read,
  render: h => h(App)
}).$mount('#app')
